import './styles.module.css';
import { CSSProperties } from 'react';

import color_scheme from '../../../styles/tokens/color_scheme.json';
import radius from '../../../styles/tokens/radius.json';

export type SkeletonProps = {
  style: CSSProperties;
};

export function Skeleton(props: SkeletonProps) {
  const { style } = props;
  return (
    <div
      className="skeleton"
      style={{
        backgroundColor: color_scheme.dark.colors.gray_alpha['3'].value,
        borderRadius: radius[2],
        ...style,
      }}
    />
  );
}
